var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "el-form",
        {
          ref: "form",
          staticClass: "img-item",
          attrs: {
            model: _vm.field,
            "label-width": _vm.field.name ? "120px" : "0"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "input-row",
              attrs: { prop: "def_val.items", rules: _vm.fieldRules }
            },
            [
              _vm.field.name
                ? _c(
                    "div",
                    {
                      staticClass: "label-item common",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _c("p", { staticClass: "label-text" }, [
                        _vm._v(_vm._s(_vm.field.desc))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "light", placement: "bottom-start" }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v("\n                    - 描述: "),
                              _c("strong", [_vm._v(_vm._s(_vm.field.desc))]),
                              _c("br"),
                              _vm._v("\n                    - name: "),
                              _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                              _c("br")
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "label-icon el-icon-info" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "checkbox-wrap" },
                [
                  _c(
                    "div",
                    { staticClass: "search-wrap" },
                    [
                      _c("span", { staticClass: "search-label" }, [
                        _vm._v("类型：")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: "输入类型，搜索出该类型的列表项目"
                        },
                        model: {
                          value: _vm.field.def_val.search_type,
                          callback: function($$v) {
                            _vm.$set(_vm.field.def_val, "search_type", $$v)
                          },
                          expression: "field.def_val.search_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-wrap" },
                    [
                      _c("span", { staticClass: "search-label" }, [
                        _vm._v("域名：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "search-input",
                          attrs: {
                            placeholder:
                              "选择域名，自动替换列表项目的图片链接上",
                            clearable: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.field.def_val.host,
                            callback: function($$v) {
                              _vm.$set(_vm.field.def_val, "host", $$v)
                            },
                            expression: "field.def_val.host"
                          }
                        },
                        _vm._l(_vm.hostOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-wrap" },
                    [
                      _c("span", { staticClass: "search-label" }, [
                        _vm._v("渠道：")
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: "输入渠道，自动绑定到列表项目的链接上"
                        },
                        model: {
                          value: _vm.field.def_val.channel,
                          callback: function($$v) {
                            _vm.$set(_vm.field.def_val, "channel", $$v)
                          },
                          expression: "field.def_val.channel"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "label-title" }, [_vm._v("待选：")]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.imgItemsCheckHandler },
                      model: {
                        value: _vm.field.def_val.items,
                        callback: function($$v) {
                          _vm.$set(_vm.field.def_val, "items", $$v)
                        },
                        expression: "field.def_val.items"
                      }
                    },
                    _vm._l(_vm.typeImgItemsByType, function(item) {
                      return _c(
                        "el-checkbox",
                        { key: item._id, attrs: { label: item._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.title) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "label-title" }, [
                    _vm._v("已选"),
                    _c("span", { staticClass: "tips" }, [
                      _vm._v("(拖动图块调整顺序)")
                    ]),
                    _vm._v("：")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.field.def_val.items.length
                        ? _c(
                            "draggable",
                            {
                              staticClass: "images-drag-area",
                              attrs: { list: _vm.field.def_val.items }
                            },
                            _vm._l(_vm.checkedImgItems, function(item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "drag-item",
                                  attrs: { title: "拖动图块调整顺序" }
                                },
                                [
                                  _c("img", {
                                    staticClass: "thumb-pic",
                                    attrs: { src: item.img_url }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "thumb-title",
                                      attrs: {
                                        href: item.link,
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-delete del-btn",
                                    attrs: { title: "点击删除" },
                                    on: {
                                      click: function($event) {
                                        return _vm.imagesDel(index)
                                      }
                                    }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.field.def_val.items.length
                        ? _c("div", { staticClass: "no-data" }, [
                            _vm._v("暂无数据")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e49bcd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e49bcd8","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/imgItem.vue
// module id = 1218
// module chunks = 7